import { render, staticRenderFns } from "./orderDIFOTCollectionTaskPerformanceWidget.vue?vue&type=template&id=04344b0c&"
import script from "./orderDIFOTCollectionTaskPerformanceWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTCollectionTaskPerformanceWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports